var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"centered":"","scrollable":"","title":"Full Text","modal-class":_vm.theme,"body-class":"modal__confirm","size":"xl","ok-only":"","ok-title":"Close"}},[_c('tree-view',{attrs:{"data":_vm.json}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }